import React from "react";

import { css } from "@emotion/react";

import { ReactTFC } from "../../../../utils/fp/missing-ts-parts";
import cn from "classnames";
import { SwarovskiTag } from "../SwarovskiTag";

export const AttributesTag: ReactTFC<{
  label: string;
  size?: "small" | "regular" | "tiny";
  dontTrim?: boolean;
  type: "plain" | "color";
  customValue: string | undefined;
}> = props => {
  return (
    <SwarovskiTag
      label={props.label}
      className={cn({
        "dont-trim": props.dontTrim,
      })}
      size={props.size}
      css={styles}
    >
      {props.type === "color" && props.customValue ? <ColorDot hex={props.customValue} /> : null}

      {props.label}
    </SwarovskiTag>
  );
};

const ColorDot: React.FC<{ hex: string }> = ({ hex }) => {
  return (
    <span
      aria-hidden="true"
      css={css`
        width: 12px;
        height: 12px;
        background-color: ${hex};
        border-radius: 50%;
        display: inline-block;

        margin-right: 6px;
        margin-left: 2px;
      `}
    />
  );
};

const styles = [
  css`
    &:not(.dont-trim) {
      max-width: 12em;
      text-overflow: ellipsis;
      overflow: hidden;
      white-space: nowrap;
    }
  `,
];
